"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nemi": {
    "4ae3cb3b": [{
      "hkey": "6c14a3ef",
      "slug": "nemi",
      "name": "Nemi",
      "primary": true,
      "skipSearch": false
    }],
    "parco-dei-lecci": [{
      "hkey": "6c14a3ef",
      "slug": "nemi",
      "name": "Nemi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e6280fec": [{
      "hkey": "6c14a3ef",
      "slug": "nemi",
      "name": "Nemi",
      "primary": true,
      "skipSearch": false
    }],
    "valle-delle-colombe": [{
      "hkey": "6c14a3ef",
      "slug": "nemi",
      "name": "Nemi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e44489e8": [{
      "hkey": "6c14a3ef",
      "slug": "nemi",
      "name": "Nemi",
      "primary": true,
      "skipSearch": false
    }],
    "valle-petrucola": [{
      "hkey": "6c14a3ef",
      "slug": "nemi",
      "name": "Nemi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "579d155f": [{
      "hkey": "6c14a3ef",
      "slug": "nemi",
      "name": "Nemi",
      "primary": true,
      "skipSearch": false
    }],
    "vigna-grande": [{
      "hkey": "6c14a3ef",
      "slug": "nemi",
      "name": "Nemi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9e0ba186": [{
      "hkey": "6c14a3ef",
      "slug": "nemi",
      "name": "Nemi",
      "primary": true,
      "skipSearch": false
    }],
    "ville-di-nemi": [{
      "hkey": "6c14a3ef",
      "slug": "nemi",
      "name": "Nemi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;